import { useEffect } from 'react';
import { supabase } from '@/lib/supabase';

/**
 * Hook que monitorea subastas terminadas cada 60 segundos
 * Ejecuta close_ended_auctions() automáticamente
 */
export function useAuctionMonitor() {
  useEffect(() => {
    const closeEndedAuctions = async () => {
      try {
        const { data, error } = await supabase.rpc('close_ended_auctions');
        
        // Silenciosamente manejar error si el RPC no existe
        if (error) {
          // Solo logear si es un error diferente a "function does not exist"
          if (!error.message?.includes('does not exist')) {
            console.error('❌ Error cerrando subastas:', error);
          }
          return;
        }
        
        if (data && data.length > 0) {
          
          // Disparar evento para refreshar carritos/notificaciones
          try {
            window.dispatchEvent(new CustomEvent('cart-updated'));
            window.dispatchEvent(new CustomEvent('auction-closed', { detail: data }));
          } catch (e) {
            console.warn('Error dispatching events:', e);
          }
        }
      } catch (err) {
        // Silencioso - no molestar al usuario
      }
    };

    // Ejecutar inmediatamente
    closeEndedAuctions();
    
    // Ejecutar cada 30 segundos (más agresivo)
    const interval = setInterval(closeEndedAuctions, 30000);
    
    return () => {
      clearInterval(interval);
    };
  }, []);
}
